import React from "react";
import capitalizeFieldHeader from "../../utilis/capitalizeFieldHeader";
import BFormField from "./BFormField";
import BCustomDropdownInput from "../inputs/BCustomDropdownInput";
import BFormSelectInput from "../inputs/BSelectInput";
import BDateFormInput from "../inputs/BDateFormInput";
import BCheckboxInput from "../inputs/BCheckboxInput";
import BTextArrayInput from "../inputs/BTextArrayInput"
import BFileInput from "../inputs/BFileInput";
import BTextareaField from "./BTextareaField";

export default function BFormFieldWrapper({
  field,
  errors,
  control,
  register,
}) {
  const {
    dateFormat,
    fieldName,
    btnText,
    itemsUrl,
    placeholder,
    filterBy,
    options,
    cols,
    rows,
    validation,
    type = "text",
    step = 1,
  } = field;

  const formatError = (error) => {
    let errorMessage = error.message;
    if (error.type === "required") {
      errorMessage = "This field is required";
    }
    return <p className="text-center text-red-500 text-xs">{errorMessage}</p>;
  };

  let fieldToReturn;

  if (type === "dropdown") {
    fieldToReturn = (
      <BCustomDropdownInput
        fieldName={fieldName}
        placeholder={placeholder}
        itemsUrl={itemsUrl}
        control={control}
        filterBy={filterBy}
      />
    );
  } else if (type === "select") {
    fieldToReturn = (
      <BFormSelectInput
        fieldName={fieldName}
        placeholder={placeholder}
        control={control}
        options={options}
      />
    );
  } else if (type === "multiselect") {
    fieldToReturn = (
      <BFormSelectInput
        fieldName={fieldName}
        placeholder={placeholder}
        control={control}
        options={options}
        multi={true}
      />
    );
  } else if (type === "date") {
    fieldToReturn = (
      <BDateFormInput
        fieldName={fieldName}
        placeholder={placeholder}
        control={control}
        dateFormat={dateFormat}
      />
    );
  } else if (type === "checkbox") {
    fieldToReturn = (
      <BCheckboxInput
        fieldName={fieldName}
        placeholder={placeholder}
        register={register}
        validation={validation}
      />
    );
  } else if (type === "file") {
    fieldToReturn = (
      <BFileInput
        fieldName={fieldName}
        placeholder={placeholder}
        control={control}
        btnText={btnText}
      />
    );
  } else if (type === "textarea") {
    fieldToReturn = (
      <BTextareaField
        fieldName={fieldName}
        placeholder={placeholder}
        register={register}
        validation={validation}
        cols={cols}
        rows={rows}
        type={type}
        step={step}
      />
    );
  } else if (type === "textarray") {
    fieldToReturn = (
      <BTextArrayInput
        fieldName={fieldName}
        placeholder={placeholder}
        validation={validation}
        register={register}
        control={control}
      />
    );
  } else {
    fieldToReturn = (
      <BFormField
        fieldName={fieldName}
        placeholder={placeholder}
        register={register}
        validation={validation}
        type={type}
        step={step}
      />
    );
  }

  return (
    <div>
      <div className="capitalize pt-4 font-bold">
        {capitalizeFieldHeader(placeholder)}
      </div>
      <div key={fieldName} className="h-1/3">
        {fieldToReturn}
        {errors && fieldName in errors && formatError(errors[fieldName])}
      </div>
    </div>
  );
}
